export default __webpack_public_path__ + "static/media/ratleverkusen.cd5e5401.png";